<template>
  <div class="bb-invoices">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"></loader-fly>
    </transition>
    <div class="bb-invoices-header">
      <h2 class="bb-page-title">Proforma Invoice Tracking</h2>
      <div class="bb-invoices-header__buttons">
        <button class="bb-button bb-invoices-header_btn" @click="$router.push({name: 'ContactsList'})">
          CRM
        </button>
        <button class="bb-button bb-invoices-header_btn" @click.stop="openPayment()">PAYMENT</button>
      </div>
    </div>
    <FilterByDate :get-query="getRequest" position="right" all-name="All"/>
    <div class="bb-invoices-totals">
      <total-card v-for="total in totalsInvoicesCard" :key='total.id'
                  class="bb-invoices-totals__item"
                  :class="{
        'bb-invoices-totals__item_active': '&' + total.filter === filterByStatus,
        'bb-invoices-totals__item_pointer': total.filter
      }"
                  @setFilter="setFilterByTotal"
                  :filter="total.filter"
                  :title="total.title"
                  :icon="total.icon"
                  :sum="total.sum"
                  :info="total.info"
                  :colorSum="total.color"/>
    </div>
    <div class="bb-invoices-tabs">
      <div class="bb-invoices-tabs__item"
           @click="getInvoices({type: 1})"
           :class="{'bb-invoices-tabs__item_active' : activeTab === tabs.allInvoices}">
        All Invoices
      </div>
      <div class="bb-invoices-tabs__item"
           v-if="hasDeleteInvoices && isFounder()"
           @click="getInvoices({type: 2})"
           :class="{'bb-invoices-tabs__item_active' : activeTab === tabs.deletedInvoices}">
        Deleted Invoices
      </div>
      <div class="bb-invoices-tabs__item"
           @click="activeTab = 3"
           :class="{'bb-invoices-tabs__item_active' : activeTab === tabs.payments}">
        List of Payments
      </div>
      <div class="bb-invoices-tabs__item bb-invoices-tabs__item_last"
           @click="activeTab = 4"
           :class="{'bb-invoices-tabs__item_active' : activeTab === tabs.creditNotes}">
        Credit Notes
      </div>
      <div class="bb-invoices-tabs__item bb-invoices-tabs__item_last"
           @click="activeTab = 5"
           :class="{'bb-invoices-tabs__item_active' : activeTab === tabs.vatDocs}">
        VAT – Outstanding Docs
      </div>
      <div class="bb-invoices-tabs-controls">
        <div class="bb-invoices-tabs-controls__select"
             v-if="contactsList.length > 0 && tabsWithClientSearch.includes(activeTab)">
          <v-select label="nickName"
                    :options="contactsList"
                    :clearable="true"
                    :placeholder="'Client Name'"
                    :value="clientSearch"
                    @search="searchFilterByClient"
                    @input="setFilterByClient"/>
        </div>
        <button class="bb-button bb-invoices-tabs-controls__button"
                @click.stop="addEntry"
                v-if="tabsWithButtonAdd.includes(activeTab)">
          ADD
        </button>
      </div>
    </div>
    <template v-if="activeTab === tabs.allInvoices || activeTab === tabs.deletedInvoices">
      <vue-perfect-scroll class="bb-invoices-table-wrapper" ref="invoiceScroll">
        <div class="bb-invoices-table">
          <table class="bb-table bb-table_invoice" ref="invoiceTable">

            <thead class="bb-table-header bb-invoices-table-header">
            <tr class="bb-table-header-row">
              <th class="bb-table-header__item bb-invoices-table__item bb-invoices-table__item-fixed
            bb-invoices-table__item-fixed_invoice bb-invoices-table__item-fixed_th"
                  ref="bbTheadInvoiceFirst"/>
              <th class="bb-table-header__item bb-invoices-table__item bb-table-header__item_hide
            bb-invoices-table__relative"/>
              <th class="bb-table-header__item bb-invoices-table__item bb-table-header__item_toolbar-invoice
            bb-invoices-table__item-fixed bb-invoices-table__item-fixed_toolbar bb-invoices-table__item-fixed_th"
                  ref="bbTheadInvoiceSecond"/>
              <th class="bb-table-header__item bb-invoices-table__item"
                  ref="bbTheadInvoice"
                  v-for="(column, index) in columns"
                  :key="column.id"
                  @mouseenter="mouseenterSection(column, 'th')"
                  @mouseleave="mouseleaveSection()"
                  v-if="sectionOpen[column.section] && !column.hide"
                  @click="column.lastInSection ? openSection(column.section) : clickThead(column)"
                  :class="{
                'bb-invoices-table__item-fixed_write-off': column.class === 'write-off',
                'bb-table-header__item_number': column.isNumber,
                'bb-table-header__business-consultant': column.property === 'businessConsultant',
                'bb-table-header__item_pointer': column.sort,
                'bb-invoices-table__item-fixed bb-invoices-table__item-fixed_th': column.fixed,
                'bb-invoices-table__item-fixed_status-manager': column.property === 'projectManagers',
                'bb-invoices-table__item-fixed_extra-value': column.property === 'currentServices.extra',
                'bb-invoices-table__item-fixed_nickname': column.property === 'client.nickName',
                'bb-invoices-table__item-fixed_number': column.property === 'number',
                'bb-invoices-table__item-fixed_issue-date': column.property === 'issueDate',
                'bb-table-header__item_wide': column.wide,
                'bb-table-header__item_select-invoice': column.type === 'select',
                'bb-table-header__item_center': column.center,
                'bb-table-separator bb-invoices-table__item_separator': column.lastInSection,
                'bb-table-end-section bb-invoices-table__item_separator': column.endSection,
                'bb-table-header__item_hide': column.hide,
                'bb-table-header__item_border': column.border,
                'bb-table-header__item_invoice': !column.lastInSection,
                'bb-table-header__item_tax-invoice': column.property === 'taxInvoice',
                'bb-table-header__item_payment-date': column.property === 'paymentDate',
                'bb-table-header__item_tax-number': column.property === 'taxInvoiceNumber'
              }">
                <div v-if="!column.lastInSection" class="bb-table-header__item-wrapper"
                     @click="openFilterPopupByStatus = column.id"
                     :class="{
                'bb-table-header__item_pointer': column.list,
                'bb-invoices-table__item_nickname': column.property === 'client.nickName',
                'bb-invoices-table__item_center': column.property === 'projectManagers',
                'bb-table-header__item_name': column.sort,
                'bb-table-header__item_status': column.property === 'status'
              }">
                  <span>{{column.title}}</span>
                  <span>
                  <i class="bb-table-header__item-icon"
                     :class="column.icon"
                     v-if="column.icon"
                     @mouseenter="showInfoTotal(index, column, $event)"
                     @mouseleave="showInfoIndex = false, activeInfo = false">
                 </i>
                 <i class="icon-arrow-sort bb-table-header__sort-icon" v-if="column.sort"
                    :class="{'bb-table-header__sort-icon_active': filterByColumn === 'client.nickName'}"/>
                  <i class="icon-arrow-select bb-table-header__sort-select"
                     v-if="column.list"/>
                  </span>
                  <transition name="fade-form">
                    <FilterPopup class="bb-table-header-row-filter"
                                 v-if="column.list && openFilterPopupByStatus === column.id"
                                 :list="column.list"
                                 :section="column"
                                 @setData="setDataFilter"/>
                  </transition>
                </div>
                <div class="bb-table-header-button" v-else>
                  <img src="@/assets/images/minus.png" class="bb-table-header-button__minus"/>
                  <img src="@/assets/images/minus.png" class="bb-table-header-button__plus"
                       :class="{'bb-table-header-button__plus_minus': sectionOpen[column.section + 1]}"/>
                  <transition name="bounce">
                    <div class="bb-table-header-popup bb-table-header-popup__section"
                         v-if="tooltipSection.id === column.id && tooltipSection.type === 'th'">
                      {{tooltipSection.name}}
                    </div>
                  </transition>
                </div>
              </th>
              <transition name="bounce">
                <div class="bb-table-header-popup" v-if="showInfoIndex"
                     :style="{left: showInfoPosition.left, top: showInfoPosition.top}">
                      <span class="bb-table-header-popup__title">
                        Total
                      </span>
                  {{convertNumber(activeInfo)}}
                </div>
              </transition>
            </tr>
            </thead>



            <tbody class="bb-table-body">
            <tr class="bb-table-body-row bb-table-body-row_invoice"
                v-for="(row, index) in invoicesList.invoices"
                :key="row.id"
                :class="{'bb-table-body-row_invoice_active bb-table-body-row_active': rowActive === index}"
                @mouseenter="setActiveRow(index)"
                @mouseleave="hideActiveRow()">
              <td class="bb-invoices-table__item-fixed"/>
              <td class="bb-table-body__item bb-table-body__item_hide">
                <div class="bb-table-body-row__after bb-table-body-row__after_invoices"
                     :style="{width: widthTable}"
                     :ref="'bbRowAfter' + index"/>
              </td>
              <td class="bb-table-body__item bb-invoices-table__item-fixed bb-invoices-table__item-fixed_toolbar">
                <button class="bb-button bb-table-body__button bb-table-body__button_invoice
                bb-table-body__button_invoice_save"
                        v-if="editedInvoice.row === row.id"
                        @click.stop="saveEditInvoice()">
                  OK
                </button>
                <i class="icon-menu bb-invoices-table__item-fixed_toolbar__icon"
                   @click.stop="setPositionToolbar($event, row)"
                   v-else-if="viewToolbar(row, index) && row.soaStatus !== 3"/>
                <img src="@/assets/images/recovery.png" class="bb-invoices__recovery"
                     v-else-if="activeTab === tabs.deletedInvoices"
                     @click.stop="recoveryInvoice(row.id)"/>
              </td>
              <td class="bb-table-body__item bb-table-body__item_capitalize"
                  v-for="column in columns"
                  :key="column.id"
                  v-if="sectionOpen[column.section] && !column.hide"
                  @click.stop="clickCell(row, column)"
                  @mouseenter="mouseenterSection(column, row.id)"
                  @mouseleave="mouseleaveSection"
                  :class="{
                'bb-invoices-table__item-fixed_status-manager': column.property === 'projectManagers',
                'bb-invoices-table__item-fixed_write-off': column.class === 'write-off',
                'bb-invoices-table__item-fixed': column.fixed,
                'bb-invoices-table__item-fixed_nickname': column.property === 'client.nickName',
                'bb-invoices-table__item-fixed_number': column.property === 'number',
                'bb-invoices-table__item-fixed_issue-date': column.property === 'issueDate',
                'bb-table-header__item_hide': column.hide,
                'bb-table-body__item_pointer': column.pointer && getProp(row, column.property, column),
                'bb-table-body__item_hover': column.pointer,
                'bb-table-body__item_editable': column.editable,
                'bb-table-separator': column.lastInSection,
                'bb-table-end-section': column.endSection,
                'bb-table-body__item_border': column.border && index === invoicesList.invoices.length - 1,
                'bb-table-body__item_invoice': !column.lastInSection,
                'bb-table-body__item_payment-date': column.property === 'paymentDate',
                'bb-table-body__item_tax-number': column.property === 'taxInvoiceNumber'
                }">
                <template v-if="column.type === 'input' && getProp(row, 'taxInvoice')">
                  <div class="bb-invoices-table-upload-files">
                    <input class="bb-table-body__input bb-input bb-input_border bb-invoices-table-upload-files__input"
                           maxlength="12"
                           v-autofocus="getInputFocus(row)"
                           :disabled="activeTab === tabs.deletedInvoices"
                           v-model="inputInvoice[row.id + column.id]"
                           @change="changeInput(inputInvoice[row.id + column.id], row, column)"
                           @keyup.enter="changeInput(inputInvoice[row.id + column.id], row, column)">
                    <Upload class="bb-table-body-upload__icon"
                            :popupDown="index !== invoicesList.invoices.length -1"
                            :files="row.uploadFile || []"
                            :view="row.taxInvoice"
                            :upload="true"
                            :item="{row, column}"
                            @view="openFile"
                            @delete="deleteFile"
                            @upload="uploadAllFiles"/>
                  </div>
                </template>
                <template v-else-if="column.property === 'client.nickName'">
                  <div class="bb-invoices-table__item__nickname">
                    <i class="icon-dollar bb-table-body__status-paid"
                       @click.stop
                       :class="'bb-table-body__status-paid_' + getProp(row, 'status', column)"/>
                    <span class="bb-invoices-table__item__nickname__text"
                          :class="{
                            'bb-invoices-table__item__nickname__text_removed': !getProp(row, column.property, column)
                          }"
                          @click.stop="goToClient(row, column)">
                    {{getProp(row, column.property, column) || column.defaultProperty}}
                  </span>
                  </div>
                </template>
                <template v-else-if="column.property === 'projectManagers'">
                  <div>
                    <i class="icon-manager bb-table-body__status-managers"
                       @click.stop="scrollToManagers()"
                       :class="'bb-table-body__status-managers_' + getProp(row, column.property, column)"/>
                  </div>
                </template>
                <template v-else-if="column.type === 'checkbox'">
                  <div class="bb-table-body__checkbox">
                    <checkbox checkbox-text=""
                              :name="row"
                              :disabled="activeTab === tabs.deletedInvoices"
                              :section="column"
                              :value="getProp(row, column.property)"
                              @checkboxChange="checkboxChange"/>
                  </div>
                </template>
                <template v-else-if="column.type === 'date'">
                  <DataPicker @setDate="setDate" :default-date="date" :obj="{row: row, column: column}"/>
                </template>
                <template v-else-if="column.modified === 'businessConsultant'">
                  <div class="bb-table-body-select" v-if="displaySelect(row, column)">
                    <div class="bb-table-body-select__select" v-if="users.length > 0">
                      <custom-select
                        :table-mode="true"
                        :list="getUsersByDepartments(1)"
                        :disabled="checkDisabledSelect(row, column)"
                        :item="{row, column}"
                        styles="denim"
                        @setValue="setBusinessConsultant"
                        :default-val="getNameBusinessConsultant(row, column) || 'Set Business Consultant'"/>
                    </div>
                  </div>
                </template>
                <template v-else-if="column.type === 'select'">
                  <div class="bb-table-body-select bb-table-body-select_invoice"
                       v-if="checkVisibleService(row, column)">
                  <span class="bb-table-body-select__number bb-table-body__item_received"
                        :class="'bb-table-body__item_received_' + getStatusPaidService(row, column)">
                    {{convertNumber(getProp(row, column.property, column))}}
                  </span>
                    <div class="bb-table-body-select__select" v-if="users.length > 0">
                      <custom-select
                        :table-mode="true"
                        :list="getUsersByDepartments(2)"
                        :disabled="activeTab === tabs.deletedInvoices || checkApproveServiceProjectManager(row, column)"
                        :item="{row, column}"
                        styles="denim"
                        @setValue="setProjectManager"
                        :default-val="getNameProjectManager(row, column) || 'Select Project Manager'"/>
                    </div>
                  </div>
                </template>
                <template v-else-if="column.comparison">
                <span class="bb-table-body__item_received"
                      :class="'bb-table-body__item_received_' + getStatusPaid(row, column).status">
                 {{getProp(row, column.property, column)}}
                </span>
                </template>
                <template v-else-if="column.applied">
                <span class="bb-table-body__item_received"
                      v-if="typeof getProp(row, column.property, column).value === 'number'">
                 {{convertNumber(getProp(row, column.property, column).value)}}
                </span>
                </template>
                <template v-else-if="column.button && (row.status === 3 || row.status === 1)">
                  <transition name="fade">
                    <button class="bb-button bb-invoices-table__write-off"
                            @click="showPopupWriteOff = true, writeOff = row"
                            v-if="rowActive === index">
                      {{column.button}}
                    </button>
                  </transition>
                </template>
                <template v-else>
               <span v-if="getProp(row, column.property, column) && getProp(row, column.property, column) !== 0">
                 {{getProp(row, column.property, column)}}
               </span>
                </template>
                <transition name="bounce" appear>
                  <div class="bb-table-header-button"
                       v-if="column.lastInSection && tooltipSection.id === column.id && tooltipSection.type === row.id">
                    <img src="@/assets/images/minus.png" class="bb-table-header-button__minus"/>
                    <img src="@/assets/images/minus.png" class="bb-table-header-button__plus"
                         :class="{'bb-table-header-button__plus_minus': sectionOpen[column.section + 1]}"/>
                    <div class="bb-table-header-popup bb-table-header-popup__section">
                      {{tooltipSection.name}}
                    </div>
                  </div>
                </transition>
              </td>
              <transition name="bounce">
                <div class="bb-popup bb-popup__invoice"
                     :style="{left: newProformaPopUpOpen.left, top: newProformaPopUpOpen.top}"
                     v-if="newProformaPopUpOpen.open === row.id"
                     v-click-outside="closeNewProformaPopup">
                  <radio name="clientType"
                         @radioChange="newProforma"
                         value="1"
                         :section="row"
                         radio-text="Individual"
                         class="bb-popup__item"/>
                  <radio name="clientType"
                         @radioChange="newProforma"
                         value="2"
                         :section="row"
                         radio-text="Entity"
                         class="bb-popup__item"/>
                </div>
              </transition>
              <transition name="bounce">
                <div class="bb-table-body__item_invoice-buttons bb-popup bb-popup__invoice bb-popup__invoice_toolbar"
                     :style="{left: toolbarPosition.left, top: toolbarPosition.top}"
                     v-if="openToolbar === row.id">
                  <Toolbar :delete-index="deleteConfirmIndex"
                           :index="index"
                           :item="row"
                           :icons="disableDeleteService(row) || !row.client.id ? 2 : 3"
                           :top="index === invoicesList.invoices.length - 1"
                           :btn-add="row.client.id"
                           :no-delete="disableDeleteService(row)"
                           :noDeleteReasons="noDeleteReasons"
                           :no-edit="disableEditService(row)"
                           @deleteOpen="deleteConfirmIndex = index"
                           @deleteClose="deleteConfirmIndex = false"
                           @openEdit="openEditInvoice"
                           @btnAdd="openNewProforma"
                           @deleteItem="openFormDelete"/>
                </div>
              </transition>
            </tr>
            </tbody>

          </table>
        </div>
      </vue-perfect-scroll>
      <transition name="fade">
        <ModalWindow v-if="proformaOpen" @close="proformaOpen = false">
          <template v-slot:buttons>
            <div class="bb-invoices__send">
              <ButtonsEdit @edit="proformaEvents.create()"
                           @delete="proformaEvents.cancel()"
                           styles="accent"
                           no-pop-up="false"
                           :left-if="clientInfo.selectServices && clientInfo.hasBankDetails"
                           btn-right-text="CANCEL"
                           btn-left-text="SAVE"/>
            </div>
          </template>
          <ProformaInvoice ref="proformaInvoice" @close="proformaOpen = false" @updateInvoices="updateInvoices"/>
        </ModalWindow>
      </transition>
      <transition name="fade">
        <ModalWindow v-if="previewProforma === editableInvoice.invoice.id" @close="previewProforma = false">
          <ProformaInvoice :view-mode="true"
                           :editableInvoice="editableInvoice"
                           @close="previewProforma = false"/>
        </ModalWindow>
      </transition>
      <transition name="fade">
        <ModalWindow v-if="proformaOpenEdit" @close="proformaOpenEdit = false">
          <template v-slot:buttons>
            <div class="bb-invoices__send">
              <ButtonsEdit @edit="proformaEdit()"
                           @delete="proformaEvents.cancel()"
                           :item="editableInvoice.invoice"
                           styles="accent"
                           no-pop-up="false"
                           btn-right-text="CANCEL"
                           :left-if="clientInfo.selectServices && clientInfo.hasBankDetails"
                           btn-left-text="SAVE"/>
            </div>
          </template>
          <ProformaInvoice ref="proformaInvoice" @close="closeEditInvoice" :editable-invoice="editableInvoice"/>
        </ModalWindow>
      </transition>
      <transition name="fade">
        <ModalWindow v-if="paymentOpen" @close="paymentOpen = false">
          <Payment @close="paymentClose()"/>
        </ModalWindow>
      </transition>
      <transition name="fade">
        <ModalWindow v-if="showPopupWriteOff" @close="showPopupWriteOff = false">
          <div class="bb-modal-delete-invoice">
            <span>Write off invoice</span>
            <p class="bb-modal-delete-invoice__number">
              {{writeOff.number}}
            </p>
            <p class="bb-modal-delete-invoice__text">
              Are you sure you want to write off from the invoice?
            </p>
            <button class="bb-modal-delete-invoice__button bb-modal-delete-invoice__button_write-off bb-button"
                    @click="writeOffInvoice()">
              WRITE OFF
            </button>
          </div>
        </ModalWindow>
      </transition>
      <transition name="fade">
        <ModalWindow v-if="deleteInvoiceConfirm.stepOne"
                     @close="deleteInvoiceConfirm.stepOne = false, deleteInvoiceConfirm.stepTwo = false">
          <div class="bb-modal-delete-invoice">
            <transition name="slide-fade">
              <span v-if="deleteInvoiceConfirm.stepOne && !deleteInvoiceConfirm.stepTwo">Step 1</span>
            </transition>
            <transition name="slide-fade">
              <span v-if="deleteInvoiceConfirm.stepOne && deleteInvoiceConfirm.stepTwo">Step 2</span>
            </transition>
            <p class="bb-modal-delete-invoice__number">
              {{deleteInvoiceConfirm.invoice.number}}
            </p>
            <p class="bb-modal-delete-invoice__text">
              Please enter DELETE
              <transition name="bounce">
                <span v-if="deleteInvoiceConfirm.stepTwo">again</span>
              </transition>
              to confirm deletion
            </p>
            <div>
              <input class="bb-input bb-input_border bb-modal-delete-invoice__input"
                     v-model="passDeleteInvoice"
                     @keyup.enter="checkConfirmDelete()"
                     :class="{
                   'bb-modal-delete-invoice__input_error': passDeleteInvoiceError}"
                     v-autofocus/>
            </div>
            <button class="bb-modal-delete-invoice__button bb-button" @click="checkConfirmDelete()">DELETE</button>
          </div>
        </ModalWindow>
      </transition>
      <transition name="fade">
        <ModalWindow v-if="extraEdit" @close="extraEdit = false">
          <div class="bb-invoices-extra">
            <div class="bb-invoices-extra__title">
              {{extraEdit.number}}
            </div>
            <div class="bb-invoices-extra-item">
              <div class="bb-invoices-extra-item__title">3rd Party Fees</div>
              <input class="bb-input bb-input_border"
                     @keyup.enter="editExtraInvoice()"
                     @input="calcValuesService(newExtra, 'value')"
                     v-model="newExtra.value">
            </div>
            <div class="bb-invoices-extra-item">
              <div class="bb-invoices-extra-item__title">Extra Profit</div>
              <input class="bb-input bb-input_border"
                     @keyup.enter="editExtraInvoice()"
                     @input="calcValuesService(newExtra)"
                     v-model="newExtra.extraValue">
            </div>
          </div>
          <template v-slot:buttons>
            <button class="bb-button bb-invoices-extra-button" @click.stop="editExtraInvoice()">SAVE</button>
          </template>
        </ModalWindow>
      </transition>
    </template>
    <template v-else-if="activeTab === tabs.creditNotes">
      <CreditNotes @setQuery="setQuery" :filterClientId="filterClientId" :newEntry="addNewEntry.credit"/>
    </template>
    <template v-else-if="activeTab === tabs.vatDocs">
      <VATDocs @setQuery="setQuery" :newEntry="addNewEntry.vat"/>
    </template>
    <template v-else>
      <ListOfPayments @setTotals="setTotals" @setQuery="setQuery"/>
    </template>
    <Pagination class="bb-pagination"
                :data="invoicesList"
                :getQuery="getInvoices"
                :limit="defLimit"
                v-if="activeTab === tabs.allInvoices || activeTab === tabs.deletedInvoices"/>
  </div>
</template>

<script>
import {columns} from '@/constants/TablesOptions/invoicesTable'
import InvoicesApi from '@/api/Invoce/api'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import Toolbar from '@/components/Main/Toolbar/Toolbar'
import TotalCard from '@/components/Finance/InvoiceTable/TotalCard/TotalCard'
import checkbox from '@/components/Main/Inputs/checkbox'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import ProformaInvoice from '@/components/Dissemination/Sales/CRM/ContactCard/ProformaInvoice/ProformaInvoice'
import Payment from '@/components/Finance/InvoiceTable/Payment/Payment'
import ButtonsEdit from '@/components/Main/ButtonsEdit/ButtonsEdit'
import ContactsApi from '@/api/Contacts/api'
import DataPicker from '@/components/Main/DataPicker/DataPicker'
import convertNumber from '@/mixin/convertNumber'
import VuePerfectScroll from 'vue-perfect-scrollbar'
import moment from 'moment'
import _ from 'lodash'
import CustomSelect from '@/components/Main/Inputs/CustomSelect'
import UsersListApi from '@/api/UsersList/api'
import ServiceProject from '@/components/Settings/Services/ServiceProject/ServiceProject'
import {FOUNDER} from '@/constants/roles'
import ListOfPayments from '@/components/Finance/InvoiceTable/ListOfPayments/ListOfPayments'
import Pagination from '@/components/Main/Pagination/Pagination'
import CreditNotes from '@/components/Finance/InvoiceTable/CreditNotes/CreditNotes'
import FilterByDate from '@/components/Main/FilterByDate/FilterByDate'
import FilterPopup from '@/components/Main/FilterPopup/FilterPopup'
import radio from '@/components/Main/Inputs/radio'
import {statusInvoiceList} from '@/constants/statusInvoiceList'
import Table from '@/components/Main/Table/Table'
import Upload from '@/components/Main/Upload/Upload'
import UploadFileApi from '@/api/UploadFile/api'
import vSelect from 'vue-select'
import VATDocs from '@/components/Finance/InvoiceTable/VATDocs/VATDocs'
import totalsInvoicesCard from '@/constants/totalsInvoicesCard'
import preventBackOnHorizontalScroll from '@/mixin/preventBackOnHorizontalScroll'
import b64toBlob from 'b64-to-blob'
import {saveAs} from 'file-saver'

export default {
  name: 'InvoicesTable',
  props: ['activeTable'],
  mixins: [convertNumber, preventBackOnHorizontalScroll],
  components: {
    VATDocs,
    Upload,
    Table,
    ServiceProject,
    CustomSelect,
    LoaderFly,
    Toolbar,
    TotalCard,
    checkbox,
    ModalWindow,
    ProformaInvoice,
    ButtonsEdit,
    DataPicker,
    Payment,
    ListOfPayments,
    VuePerfectScroll,
    Pagination,
    CreditNotes,
    FilterByDate,
    FilterPopup,
    radio,
    vSelect
  },
  data: function () {
    return {
      activeTab: 1,
      tabs: {
        allInvoices: 1,
        deletedInvoices: 2,
        payments: 3,
        creditNotes: 4,
        vatDocs: 5
      },
      writeOff: {},
      showPopupWriteOff: false,
      clientSearch: '',
      filterByClient: '',
      filterClientId: '',
      addNewEntry: {
        credit: false,
        vat: false
      },
      theadFixed: false,
      toolbarPosition: {
        left: 0,
        top: 0
      },
      openToolbar: false,
      allValues: {},
      newProformaPopUpOpen: {
        left: 0,
        top: 0,
        open: false
      },
      previewProforma: '',
      widthTable: '100%',
      tooltipSection: {
        name: '',
        id: '',
        type: ''
      },
      openFilterPopupByStatus: false,
      filterByColumn: 'issueDate&sort[]=-1',
      getRequest: this.getInvoices,
      filterByDate: this.defaultRangeDate,
      filterByStatus: '',
      filterByManager: '',
      noDeleteReasons: [
        {
          property: 'isSoaCreditNote',
          text: 'Credit note is issued against the invoice. Inv. cannot be amended.'
        },
        {
          property: 'isShortfall',
          text: 'Proforma for shortfall is issued. Inv. cannot be amended.'
        },
        {
          property: 'isSoaProforma',
          text: 'Proforma for shortfall is issued. Inv. cannot be amended.'
        }
      ],
      defLimit: 25,
      editedInvoice: {},
      hasDeleteInvoices: false,
      extraEdit: false,
      newExtra: {
        value: 0,
        extraValue: 0,
        row: 0
      },
      statusUpload: false,
      passDeleteInvoice: '',
      passDeleteInvoiceError: false,
      deleteInvoiceConfirm: {
        invoice: {},
        stepOne: false,
        stepTwo: false
      },
      totalsInvoicesCard: totalsInvoicesCard,
      invoiceStatus: statusInvoiceList,
      loaderRun: false,
      date: new Date(),
      received: false,
      columns,
      paymentOpen: false,
      showInfoIndex: false,
      showInfoPosition: {
        left: 0,
        top: 0
      },
      activeInfo: false,
      rowActive: false,
      proformaOpen: false,
      proformaOpenEdit: false,
      editableInvoice: {
        index: false,
        invoice: false
      },
      proformaEvents: {
        create: false,
        cancel: false
      },
      deleteConfirmIndex: false,
      hideRowEffect: false,
      inputAutofocus: {},
      inputInvoice: {},
      sectionWidth: {},
      appliedThird: {},
      appliedAdmin: {},
      appliedBB: {},
      sectionOpen: {
        1: true,
        3: true,
        8: true
      },
      scrollSection: {},
      crypt: true,
      files: {}
    }
  },
  computed: {
    currentCompany () {
      return this.$store.getters.currentCompany
    },
    tabsWithClientSearch () {
      return [this.tabs.allInvoices, this.tabs.deletedInvoices, this.tabs.creditNotes]
    },
    tabsWithButtonAdd () {
      return [this.tabs.creditNotes, this.tabs.vatDocs]
    },
    mainScroll () {
      return this.$store.getters.mainScroll
    },
    defaultRangeDate () {
      const start = moment().subtract(10, 'years').format('YYYY-MM-DD')
      const end = moment().format('YYYY-MM-DD')
      return `issueDate=${start};;${end}`
    },
    userInfo: function () {
      return this.$store.getters.userInfo
    },
    invoicesList: {
      get: function () {
        return this.$store.getters.invoicesList
      },
      set: function (data) {
        this.$store.dispatch('setInvoicesList', data)
      }
    },
    invoicesTotalList: {
      get: function () {
        return this.$store.getters.invoicesTotal
      },
      set: function (data) {
        this.$store.dispatch('setInvoicesTotal', data)
      }
    },
    clientInfo: {
      get: function () {
        return this.$store.getters.clientInfo
      },
      set: function (data) {
        this.$store.dispatch('setClientInfo', data)
      }
    },
    contactsList: {
      get: function () {
        return this.$store.getters.contactsList
      },
      set: function (data) {
        this.$store.dispatch('setContactsList', data)
      }
    },
    users: {
      get: function () {
        return this.$store.getters.usersList
      },
      set: function (data) {
        this.$store.dispatch('setUsersList', data)
      }
    },
    activeCompany: function () {
      return this.$store.getters.activeCompany
    }
  },
  methods: {
    updateColumnTitle () {
      const { serviceName = 'BB' } = this.currentCompany
      this.columns.forEach((el) => {
        if (el.property === 'totalServices.bbTotal') el.title = `${serviceName} Services, AED`
        if (el.property === 'currentServices.bb') el.title = `Applied ${serviceName} Services, AED`
      })
    },
    createTotalsInvoicesCard () {
      const { serviceName = 'BB' } = this.currentCompany
      this.totalsInvoicesCard.income.title = `${serviceName} TOTAL INCOME`
    },
    deleteFile (fileId, item) {
      const row = _.get(item, 'row', {})
      UploadFileApi.deleteFile(fileId, this.crypt)
        .then((resp) => {
          _.set(row, 'uploadFile', resp.data)
          this.editInvoices({
            uploadFile: []
          }, row.id)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    uploadAllFiles (files, item) {
      const row = _.get(item, 'row', {})
      _.forEach(files, file => {
        const fileFull = this.setFileData(file)
        _.set(row, 'uploadFile', [fileFull])
        this.uploadFiles(fileFull, row)
      })
    },
    uploadFiles (fileData, row) {
      UploadFileApi.createFile(fileData, this.crypt)
        .then((resp) => {
          _.set(row, 'uploadFile', resp.data)
          this.editInvoices({
            uploadFile: resp.data.id
          }, row.id)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    setFileData (file) {
      const fileData = new FormData()
      fileData.set('fieldname', 'uploadFile')
      fileData.set('label', file.name || '')
      fileData.set('file', file)
      return fileData
    },
    openFile (file) {
      this.files[file.id] ? saveAs(this.files[file.id].blob, this.files[file.id].label) : this.getFile(file)
    },
    getFile (file) {
      this.loaderRun = true
      UploadFileApi.getFile(file.id, this.crypt)
        .then((resp) => {
          const blob = b64toBlob(resp.data.base64, resp.data.type)
          this.files[resp.data.id] = {id: resp.data.id, blob, label: resp.data.label}
          saveAs(blob, resp.data.label)
          this.loaderRun = false
        })
        .catch((err) => {
          console.error(err)
          this.loaderRun = false
        })
    },
    setFilterByStatus (item, data, list) {
      // 0 - not_paid
      // 1 - underpaid
      // 2 - paid
      // 3 - overpaid
      const target = _.find(list, {id: item.id})
      if (target) target.checked = data
      this.filterByStatus = ''
      const allChecked = _.every(list, ['checked', true])
      if (allChecked) return
      list.forEach(type => {
        let status
        if (type.id === 'not_paid') status = 0
        if (type.id === 'underpaid') status = 1
        if (type.id === 'paid') status = 2
        if (type.id === 'overpaid') status = 3
        if (type.checked) this.filterByStatus += `&status[]=${status}`
      })
    },
    setFilterByManager (item, data, list) {
      const target = _.find(list, {id: item.id})
      if (target) target.checked = data
      this.filterByManager = ''
      const allChecked = _.every(list, ['checked', true])
      if (allChecked) return
      list.forEach(type => {
        if (type.checked) this.filterByManager += `&isAssigned[]=${type.id}`
      })
    },
    setDataFilter (data, item, section, list) {
      if (section.property === 'projectManagers') {
        this.setFilterByManager(item, data, list)
      }
      if (section.property === 'status') {
        this.setFilterByStatus(item, data, list)
      }
      this.getInvoices({})
    },
    addEntry (e) {
      const credit = this.activeTab === this.tabs.creditNotes
      const vat = this.activeTab === this.tabs.vatDocs
      this.addNewEntry = {
        credit: credit ? e : false,
        vat: vat ? e : false
      }
    },
    searchFilterByClient (word) {
      if (!word) {
        this.contactsList = _.orderBy(this.contactsList, ['nickName'], ['asc'])
      } else {
        const reg = new RegExp('^' + word, 'gmi')
        this.contactsList = this.contactsList.sort((a, b) => {
          return reg.test(b.nickName) - reg.test(a.nickName)
        })
      }
    },
    setFilterByClient (item) {
      this.filterClientId = item ? item.id : ''
      this.filterByClient = item ? `&client[]=${item.id}` : ''
      this.clientSearch = item ? item.nickName : ''
      const tabAllInvoices = this.activeTab === this.tabs.allInvoices
      const tabDeletedInvoices = this.activeTab === this.tabs.deletedInvoices
      if (tabAllInvoices || tabDeletedInvoices) {
        this.getInvoices({})
      }
    },
    setFilterByTotal (value) {
      const filter = '&' + value
      this.filterByStatus = filter === this.filterByStatus ? '' : filter
      this.getInvoices({type: 1})
    },
    calcWidthTable () {
      const widthTable = _.get(this.$refs, 'invoiceTable.offsetWidth', false)
      if (widthTable) {
        this.widthTable = widthTable + 'px'
      }
    },
    setActiveRow (index) {
      this.openToolbar = false
      _.delay(() => {
        this.rowActive = index
      }, 100)
    },
    hideActiveRow () {
      this.rowActive = false
      this.deleteConfirmIndex = false
      this.openToolbar = false
      this.closeNewProformaPopup()
    },
    isFounder () {
      return this.userInfo.role === FOUNDER.id
    },
    editExtraInvoice () {
      const index = _.findIndex(this.extraEdit.services, {_id: this.newExtra.row._id})
      const indexInvoice = _.findIndex(this.invoicesList.invoices, {id: this.extraEdit.id})
      const filesIds = _.map(this.invoicesList.invoices[indexInvoice].uploadFile, item => item.id)
      this.extraEdit.services[index].value = this.validateNum(this.newExtra.value)
      this.extraEdit.services[index].extraValue = this.validateNum(this.newExtra.extraValue)
      let extraTotal = 0
      let value = 0
      _.forEach(this.extraEdit.services, service => {
        if (service.category === 1) {
          extraTotal += +service.extraValue || 0
          value += +service.value
        }
        service.id = service._id
        delete service._id
      })
      const invoice = {
        extraModify: true,
        totalServices: {
          extraTotal: extraTotal,
          thirdSideTotal: value
        },
        services: this.extraEdit.services,
        ibanList: this.invoicesList.invoices[indexInvoice].ibanList,
        uploadFile: filesIds
      }
      InvoicesApi.editInvoices(invoice, this.extraEdit.id)
        .then((resp) => {
          this.invoicesList.invoices[indexInvoice].uploadFile = resp.data.uploadFile || []
          this.invoicesList.invoices[indexInvoice].services = resp.data.services
          this.invoicesList.invoices[indexInvoice].totalServices = resp.data.totalServices
          this.invoicesList.invoices[indexInvoice].currentServices = resp.data.currentServices
        })
        .catch((err) => {
          console.error(err)
        })
      this.getInvoicesTotal({query: this.filterByDate, limit: this.defLimit})
      this.extraEdit = false
    },
    writeOffInvoice () {
      InvoicesApi.writeOffInvoices(this.writeOff.id)
        .then((resp) => {
          this.showPopupWriteOff = false
          this.writeOff = {}
          this.updateInvoices()
        })
        .catch((err) => console.error(err))
    },
    paymentClose () {
      this.paymentOpen = false
      this.getInvoices({type: 1})
    },
    calcValuesService (service, type) {
      const value = this.validateNum(service.value)
      const extraValue = this.validateNum(service.extraValue)
      const sum = (this.newExtra.row.extraValue || 0) + this.newExtra.row.value
      if (value > sum) {
        service.extraValue = 0
        service.value = sum
        return
      }
      if (extraValue > sum) {
        service.extraValue = sum
        service.value = 0
        return
      }
      if (type === 'value') {
        service.extraValue = sum - value
      } else {
        service.value = sum - extraValue
      }
    },
    validateNum (num) {
      let trueNumber = num
      if (typeof trueNumber === 'string') {
        trueNumber = +trueNumber.replace(/[-,]/, '')
      }
      return isNaN(trueNumber) ? 0 : trueNumber
    },
    mouseenterSection (column, type) {
      if (!column.lastInSection || type === 'th') return
      this.tooltipSection = {
        id: column.id,
        name: column.nameSection,
        type: type
      }
    },
    mouseleaveSection () {
      this.openFilterPopupByStatus = false
      this.tooltipSection = {
        id: '',
        name: ''
      }
    },
    clickCell (row, column) {
      if (column.lastInSection) {
        this.openSection(column.section)
      }
      if (column.openInvoice) {
        this.previewProforma = row.id
        this.editableInvoice = {
          invoice: row
        }
      }
      if (this.editedInvoice.row && this.editedInvoice.row !== row.id) {
        const lastModifiedIndex = _.findIndex(this.invoicesList.invoices, {id: this.editedInvoice.row})
        const invoice = _.cloneDeep(this.invoicesList.invoices[lastModifiedIndex])
        this.$set(this.invoicesList.invoices, [lastModifiedIndex], invoice)
        this.editedInvoice = {}
      }
    },
    scrollToManagers () {
      this.$set(this.sectionOpen, 4, true)
      this.$set(this.sectionOpen, 5, true)
      this.$set(this.sectionOpen, 6, true)
      this.$set(this.sectionOpen, 7, true)
      _.delay(this.scrollTableLeft, 200, 40)
    },
    scrollTableLeft (delay) {
      const thead = document.querySelector('.bb-table-header__business-consultant')
      const table = _.get(this.$refs, 'invoiceScroll.$el', '')
      if (!table) return
      const positionThead = thead.getBoundingClientRect() || {}
      const leftTo = positionThead.left ? positionThead.left - 816 + table.scrollLeft : 1800
      table.scrollLeft = 0
      const initialPosition = table.scrollLeft
      const allSteps = Math.abs(initialPosition - leftTo)
      const step = allSteps / delay
      const interval = setInterval(() => {
        if (table.scrollLeft >= (leftTo - 50) || table.scrollLeft >= parseInt(this.widthTable, 10)) {
          clearInterval(interval)
          _.delay(this.calcWidthTable, 100)
        }
        table.scrollLeft += step
      }, 1)
    },
    goToClient (row, column) {
      const id = _.get(row, 'client.id', '')
      if (!id) return
      this.$router.push({name: 'ContactCard', params: {id: id}})
    },
    closeEditInvoice (edit) {
      this.proformaOpenEdit = false
      if (edit) {
        this.getInvoices({type: 1})
      }
    },
    proformaEdit () {
      this.proformaEvents.edit()
    },
    showInfoTotal (index, column, e) {
      this.activeInfo = this.invoicesTotalList[column.info]
      this.showInfoPosition = {
        left: e.clientX - 15 + 'px',
        top: e.clientY - 60 + 'px'
      }
      this.showInfoIndex = index
    },
    getNameProjectManager (row, column) {
      const extra = column.dynamicService === 'thirdSideService'
      const category = extra ? 1 : 2
      const services = this.getServicesByCategory(row.services, category, extra)
      const index = column.index
      if (!services[index]) {
        return
      }
      const property = extra ? 'extraProjectManager' : 'projectManager'
      const projectManagerId = _.get(services[index], property, '')
      return _.find(this.users, {id: projectManagerId})
    },
    getNameBusinessConsultant (row, column) {
      const editedId = _.get(this.editedInvoice, 'row', '')
      if (editedId === row.id) {
        const businessConsultantId = this.getProp(this.editedInvoice, column.property, column)
        return _.find(this.users, {id: businessConsultantId})
      } else {
        const businessConsultantId = this.getProp(row, column.property, column)
        return _.find(this.users, {id: businessConsultantId})
      }
    },
    checkApproveServiceProjectManager (row, column) {
      const extra = column.dynamicService === 'thirdSideService'
      const property = extra ? 'approvedExtraValue' : 'approvedValue'
      const category = extra ? 1 : 2
      const index = column.index
      const services = this.getServicesByCategory(row.services, category, extra)
      if (!services[index]) return
      const approvedValue = _.get(services[index], property, 0)
      return approvedValue > 0
    },
    checkApproveServiceBusinessConsultant (row, col) {
      const extra = col.property === 'extraBusinessConsultant'
      const props = extra ? 'approvedExtraValueBusinessConsultant' : 'approvedValueBusinessConsultant'
      const services = _.filter(row.services, service => service[props] > 0)
      return services.length
    },
    getServicesByCategory (array, category, extra) {
      return _.filter(array, service => {
        const filterByCategory = service.category === category
        const filterByExtra = service.extraValue > 0
        return extra ? filterByCategory && filterByExtra : filterByCategory
      }) || []
    },
    setProjectManager (item, obj) {
      const row = obj.row
      const column = obj.column
      const extra = column.dynamicService === 'thirdSideService'
      const category = extra ? 1 : 2
      const services = this.getServicesByCategory(row.services, category, extra)
      const index = column.index
      const property = extra ? 'extraProjectManager' : 'projectManager'
      if (services[index][property] === item.id) {
        return
      }
      services[index][property] = item.id
      this.editedInvoice.row = row.id
      _.set(this.editedInvoice, column.property, _.get(row, column.property, ''))
    },
    getUsersByDepartments (type) {
      const users = _.filter(this.users, user => {
        const position = user.position || {}
        const department = position.department
        return department === type
      })
      const groupUsers = _.groupBy(users, 'isNotAssigned')
      const isNotAssigned = groupUsers.true || []
      const sortedUsers = _.orderBy(groupUsers.false, [item => item.firstName.toLowerCase()], ['asc'])
      return [...sortedUsers, ...isNotAssigned]
    },
    checkDisabledSelect (row, column) {
      const approved = this.checkApproveServiceBusinessConsultant(row, column)
      const tabDeletedInvoices = this.activeTab === this.tabs.deletedInvoices
      return approved || tabDeletedInvoices
    },
    setBusinessConsultant (item, obj) {
      const row = obj.row
      const column = obj.column
      if (_.get(row, column.property, '') === item.id) {
        return
      }
      this.editedInvoice.row = row.id
      _.set(this.editedInvoice, column.property, item.id)
    },
    displaySelect (row, column) {
      if (column.property === 'extraBusinessConsultant') {
        const servicesWithExtra = this.getServicesByCategory(row.services, 1, true)
        return servicesWithExtra.length > 0
      }
      return true
    },
    checkboxChange (data, row, column) {
      _.set(row, column.property, data)
      _.set(this.inputAutofocus, row.id, data)
      this.$set(row, 'taxInvoiceNumber', '')
      this.editInvoices({
        [column.property]: data,
        taxInvoiceNumber: ''
      }, row.id)
    },
    getStatusPaid (row, column, data) {
      let value
      if (data) {
        value = data
      } else {
        value = _.get(row, 'received', column)
      }
      if (typeof value === 'string') {
        value = +value.replace(',', '')
      }
      let total = _.get(row, column.comparison) || 0
      if (typeof total === 'string') {
        total = +total.replace(',', '')
      }
      const status = _.get(row, 'status', 0)
      const invoiceStatus = this.invoiceStatus.find(item => item.id === status) || this.invoiceStatus[0]
      return {
        code: invoiceStatus.id,
        status: invoiceStatus.name,
        value: this.convertNumber(Math.abs(total - value))
      }
    },
    getInputFocus (row) {
      return this.inputAutofocus[row.id] || false
    },
    changeInput (data, row, column) {
      _.set(row, column.property, data)
      this.editInvoices({
        [column.property]: data
      }, row.id)
    },
    setDate (date, object) {
      _.set(object.row, object.column.property, date)
      this.editInvoices({
        [object.column.property]: date
      }, object.row.id)
    },
    clickThead (column) {
      if (!column.sort) return
      if (column.property === this.filterByColumn) {
        this.filterByColumn = column.property + '&sort[]=-1'
      } else {
        this.filterByColumn = column.property
      }
      this.getInvoices({})
    },
    openSection (section) {
      if (this.sectionOpen[section + 1] === true) {
        if (section === 3) {
          this.$set(this.sectionOpen, 5, false)
          this.$set(this.sectionOpen, 6, false)
          this.$set(this.sectionOpen, 7, false)
        }
        this.$set(this.sectionOpen, section + 1, false)
        this.$refs.invoiceScroll.$el.scrollLeft = _.get(this.scrollSection, section, 0)
      } else {
        if (section === 3) {
          this.$set(this.sectionOpen, 6, true)
        }
        _.set(this.scrollSection, section, this.$refs.invoiceScroll.$el.scrollLeft)
        this.$set(this.sectionOpen, section + 1, true)
      }
      _.delay(this.calcWidthTable, 200)
      _.delay(this.setFixedThead, 100)
    },
    calcApplied (total, value) {
      if (value === 0) {
        return {
          value: '',
          status: 'n/a'
        }
      }
      if (typeof value === 'string') {
        value = +value.replace(',', '')
      }
      if (total < 1 || !total || isNaN(total)) {
        return {
          value: 0,
          status: 'underpaid'
        }
      } else if (total - value >= 0) {
        return {
          value: value,
          status: 'overpaid'
        }
      } else {
        return {
          value: Math.abs(total),
          status: 'underpaid'
        }
      }
    },
    calcSumByCategory (row, property, params) {
      const services = _.get(row, property, '')
      const filteredServices = _.filter(services, params)
      const total = _.reduce(filteredServices, (sum, item) => {
        let amount = +item.value * item.quantity
        if (item.discount) {
          amount = amount - (amount * item.discount / 100)
        }
        return sum + amount
      }, 0)
      return total
    },
    calcServiceVal (service) {
      let total = 0
      const value = service ? service.value : 0
      const discount = service ? service.discount : 0
      const qty = service ? service.quantity : 1
      let discountValue = (discount * value) / 100
      total = value - discountValue
      return this.roundNum(total * qty)
    },
    checkVisibleService (row, column) {
      const value = this.getProp(row, column.property, column)
      const status = this.getStatusPaidService(row, column)
      const typeService = column.dynamicService
      const extraValue = this.getExtraValue(row, column)
      const accessExtra = typeService === 'thirdSideService' && extraValue > 0
      const accessType = typeService === 'bbService' || accessExtra
      return value > 0 || (accessType && status)
    },
    getExtraValue (row, column) {
      const type = column.dynamicService === 'bbService' ? 2 : 1
      const services = this.getServicesByCategory(row.services, type, type === 1)
      const service = _.get(services, column.index, '')
      return _.get(service, 'extraValue', 0)
    },
    getStatusPaidService (row, column) {
      const type = column.dynamicService === 'bbService' ? 2 : 1
      const services = this.getServicesByCategory(row.services, type, type === 1)
      const service = _.get(services, column.index, '')
      const status = _.get(row, 'status', 0)
      const invoiceStatus = this.invoiceStatus.find(item => item.id === status) || this.invoiceStatus[0]
      if (!service) return
      return invoiceStatus.name
    },
    getProp (row, property, column) {
      const readyVal = this.allValues[property][row.id]
      if (readyVal && property !== 'services') return readyVal
      const value = _.get(row, property, '')
      if (/date/gi.test(property) && moment(value).isValid()) {
        return moment(new Date(value)).format('DD-MMM-YY')
      }
      if (property === 'projectManagers') {
        const projectManagers = this.setAllProjectManagers(row.id)
        const businessConsultant = _.get(row, 'businessConsultant', '')
        const allSet = projectManagers && businessConsultant
        return allSet ? 'success' : 'warning'
      }
      if (property === 'status') {
        return this.getStatusPaid(row, column, row.received).status
      }
      if (property === 'amount') {
        return this.getStatusPaid(row, column, value).value
      }
      if (property === 'services' && column.type === 'select' && column.dynamicService === 'bbService') {
        const bbServices = this.getServicesByCategory(row.services, 2, false)
        const service = bbServices[column.index]
        return _.get(service, 'currentValue', 0)
      }
      if (property === 'services' && column.type === 'select' && column.dynamicService === 'thirdSideService') {
        const thirdSideService = this.getServicesByCategory(row.services, 1, true)
        const service = thirdSideService[column.index] || {}
        return _.get(service, 'currentExtraValue', 0)
      }
      if (property === 'services') {
        let sum = this.calcSumByCategory(row, property, {category: column.serviceType})
        if (typeof sum === 'string') {
          sum = +sum.replace(',', '')
        }
        if (sum === 0) {
          return
        }
        return this.convertNumber(sum)
      }

      if (property === 'vat' && column.applied) {
        return this.calcApplied(row.received, value)
      }
      if (property === 'vat') {
        return this.convertNumber(value)
      }
      if (typeof value === 'number') {
        return this.convertNumber(value)
      }
      return value
    },
    setPositionToolbar (e, row) {
      this.openToolbar = row.id
      this.toolbarPosition = {
        left: e.clientX - 10 + 'px',
        top: e.clientY + 10 + 'px'
      }
    },
    viewToolbar (row, index) {
      const active = this.rowActive === index
      const tab = this.activeTab === this.tabs.allInvoices
      const noButton = this.editedInvoice.row !== row.id
      return active && tab && noButton
    },
    disableEditService (row) {
      const isSoaProforma = _.get(row, 'isSoaProforma', false)
      return !!(isSoaProforma)
    },
    disableDeleteService (row) {
      const services = _.get(row, 'services', [])
      const approves = [
        'approvedValue',
        'approvedValueBusinessConsultant',
        'serviceExtraApprovedValue',
        'servicesApprovedExtraValueBusinessConsultant'
      ]
      const resultApproves = []
      approves.forEach(approve => {
        const index = _.findIndex(services, item => item[approve] > 0)
        resultApproves.push(index)
      })
      const approved = resultApproves.some(item => item !== -1)
      const indexTransfer = _.findIndex(services, item => {
        const transfersSize = _.get(item, 'transfer.length', 0)
        return transfersSize > 0
      })
      const hasTransfer = indexTransfer !== -1
      const indexExpiredPaid = _.findIndex(services, item => {
        return item.expireCategory && item.currentValue
      })
      const hasExpirePaid = indexExpiredPaid !== -1
      return !!(approved || hasTransfer || hasExpirePaid)
    },
    openNewProforma (row, e) {
      this.newProformaPopUpOpen = {
        left: `${e.clientX - 10}px`,
        top: `${e.clientY + 13.5}px`,
        open: row.id
      }
    },
    closeNewProformaPopup () {
      this.newProformaPopUpOpen = {
        left: '',
        top: '',
        open: false
      }
    },
    openEditInvoice (index, item) {
      this.editableInvoice.index = index
      this.editableInvoice.invoice = item
      this.proformaOpenEdit = true;
      this.openToolbar = false;
    },
    newProforma (value, item) {
      this.closeNewProformaPopup()
      this.getClient(item.client.id, value)
    },
    setInputs () {
      if (this.invoicesList.invoices.length > 0 && this.columns.length > 0) {
        _.forEach(this.invoicesList.invoices, row => {
          _.forEach(this.columns, column => {
            this.inputInvoice[row.id + column.id] = _.get(row, column.property, '')
          })
        })
      }
    },
    getClient (id, invoiceType) {
      ContactsApi.getContact(id)
        .then((resp) => {
          resp.data.invoiceType = invoiceType
          this.clientInfo = resp.data
          this.proformaOpen = true
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getUserList () {
      UsersListApi.getUsersList({limit: 1000, assigned: true})
        .then((resp) => {
          this.users = _.filter(resp.data.users, item => item)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getContactsList () {
      ContactsApi.getContactsList({limit: 1000})
        .then((resp) => {
          this.contactsList = resp.data.clients
        })
        .catch((err) => {
          console.error(err)
        })
    },
    checkDeletedInvoices () {
      InvoicesApi.getInvoices({query: 'isDelete[]=true', limit: this.defLimit})
        .then((resp) => {
          this.hasDeleteInvoices = resp.data.invoices.length
        }).catch((err) => {
          console.error(err)
        })
    },
    openPayment () {
      this.paymentOpen = true
      this.activeTab = 1
      this.getInvoices({})
    },
    getUniqueService (invoices, categoryType) {
      let length = 0
      const isExtra = categoryType === 1
      invoices.forEach(invoice => {
        const lengthBB = this.getServicesByCategory(invoice.services, categoryType, isExtra).length
        length = lengthBB > length ? lengthBB : length
      })
      const bbServices = []
      for (let i = 0; i < length; i++) {
        const name = isExtra ? 'Extra Service ' : 'Service '
        bbServices.push(name + (i + 1))
      }
      return bbServices
    },
    setDynamicColumns ({id = '', property, type, dynamicService, section, array}) {
      _.forEach(array, (item, index) => {
        const obj = {
          id: item + id,
          title: item,
          property: 'services',
          type: type,
          serviceType: item,
          border: true,
          dynamicService: dynamicService,
          section: section,
          index: index
        }
        const indexDynamic = _.findIndex(this.columns, {'property': property})
        const service = _.find(this.columns, {id: obj.id})
        if (!service) {
          this.columns.splice(indexDynamic, 0, obj)
        }
      })
    },
    getFullQuery () {
      let query = ''
      this.activeTab === this.tabs.deletedInvoices ? query = 'isDelete[]=true' : query = 'isDelete[]=false'
      if (this.filterByStatus) query += this.filterByStatus
      if (this.filterByManager) query += this.filterByManager
      if (this.filterByClient) query += this.filterByClient
      query += `&${this.filterByDate}`
      if (this.filterByColumn) query += `&sort[]=${this.filterByColumn}`
      return query
    },
    getInvoices ({page, type, filter}) {
      if (page) {
        this.scrollToUp()
      }
      type = type || this.activeTab
      if (this.activeTab === type && this.invoicesList.left > 0) {
        return
      } else {
        this.activeTab = type
      }
      if (filter) {
        this.filterByDate = `issueDate=${filter}`
      }
      const query = this.getFullQuery()
      this.getRequest = this.getInvoices
      this.loaderRun = true
      this.getInvoicesTotal()
      InvoicesApi.getInvoices({query, limit: this.defLimit, page})
        .then((resp) => {
          this.invoicesList = resp.data
          this.setInputs()
          const uniqueBBService = this.getUniqueService(this.invoicesList.invoices, 2)
          const bbParams = {
            property: 'dynamic',
            type: 'select',
            dynamicService: 'bbService',
            section: 5,
            array: uniqueBBService
          }
          this.setDynamicColumns(bbParams)
          this.deleteOldDynamicServices(uniqueBBService, 'bbService')
          const uniqueThirdSideService = this.getUniqueService(this.invoicesList.invoices, 1)
          const thirdSideParams = {
            id: 'uniqueThirdSideService',
            property: 'dynamicThirdSideService',
            type: 'select',
            dynamicService: 'thirdSideService',
            section: 7,
            array: uniqueThirdSideService
          }
          this.setDynamicColumns(thirdSideParams)
          this.deleteOldDynamicServices(uniqueThirdSideService, 'thirdSideService')
          this.loaderRun = false
          this.calcWidthTable()
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    deleteOldDynamicServices (array, service) {
      const newColumns = _.cloneDeep(this.columns)
      _.forEach(newColumns, (item) => {
        if (!item) {
          return
        }
        if (item.dynamicService === service) {
          const include = _.includes(array, item.title)
          if (!include) {
            const index = _.findIndex(this.columns, item)
            this.columns.splice(index, 1)
          }
        }
      })
    },
    getInvoicesTotal () {
      const query = this.getFullQuery()
      InvoicesApi.getInvoicesTotal({query})
        .then((resp) => {
          this.invoicesTotalList = resp.data
          this.setTotals(resp.data)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    saveEditInvoice () {
      const id = this.editedInvoice.row
      delete this.editedInvoice.row
      this.editInvoices(this.editedInvoice, id)
    },
    editInvoices (invoice, id) {
      const index = (_.findIndex(this.invoicesList.invoices, {id: id}))
      const properties = Object.keys(invoice)
      const newFile = invoice.uploadFile
      const oldFile = _.map(this.invoicesList.invoices[index].uploadFile, item => item.id)
      invoice.services = this.invoicesList.invoices[index].services
      invoice.ibanList = this.invoicesList.invoices[index].ibanList
      invoice.uploadFile = newFile || oldFile
      InvoicesApi.editInvoices(invoice, id)
        .then((resp) => {
          this.editedInvoice = {}
          properties.forEach(property => {
            this.invoicesList.invoices[index][property] = resp.data[property]
          })
          this.getInvoicesTotal()
          this.setAllValue()
        })
        .catch((err) => {
          console.error(err)
        })
    },
    checkConfirmDelete () {
      if (this.deleteInvoiceConfirm.stepTwo && this.passDeleteInvoice === 'DELETE') {
        this.deleteInvoices(this.deleteInvoiceConfirm.invoice.id)
        this.passDeleteInvoice = ''
        this.passDeleteInvoiceError = false
        return
      } else {
        this.passDeleteInvoiceError = true
      }
      if (this.passDeleteInvoice === 'DELETE') {
        this.deleteInvoiceConfirm.stepTwo = true
        this.passDeleteInvoiceError = false
      } else {
        this.passDeleteInvoiceError = true
      }
      this.passDeleteInvoice = ''
    },
    openFormDelete (index, id) {
      const item = _.find(this.invoicesList.invoices, {id: id})
      this.deleteInvoiceConfirm.invoice = item
      this.deleteInvoiceConfirm.stepOne = true
    },
    recoveryInvoice (id) {
      const trueIndex = (_.findIndex(this.invoicesList.invoices, {id: id}))
      InvoicesApi.recoveryInvoice(id)
        .then((resp) => {
          this.invoicesList.invoices.splice(trueIndex, 1)
          if (this.invoicesList.invoices.length === 0) {
            this.activeTab = 1
            this.getInvoices({type: 1})
          }
          this.hasDeleteInvoices = this.invoicesList.invoices.length
          this.getInvoicesTotal()
        })
        .catch((err) => {
          console.error(err)
        })
    },
    deleteInvoices (id) {
      this.deleteInvoiceConfirm.invoice = {}
      this.deleteInvoiceConfirm.stepTwo = false
      this.deleteInvoiceConfirm.stepOne = false
      this.proformaOpenEdit = false
      const trueIndex = (_.findIndex(this.invoicesList.invoices, {id: id}))
      InvoicesApi.deleteInvoices(id)
        .then((resp) => {
          this.hasDeleteInvoices = true
          this.deleteConfirmIndex = false
          this.invoicesList.invoices.splice(trueIndex, 1)
          this.getInvoices({type: 2})
        })
        .catch((err) => {
          console.error(err)
        })
    },
    roundNum (num) {
      return Math.round(num * 100) / 100
    },
    setQuery (data) {
      this.getRequest = data
    },
    setTotals (totals) {
      const { serviceName = 'BB' } = this.currentCompany
      const infoIncome = [
        `Admin Fees ${this.convertNumber(totals.adminCurrentTotal)}`,
        `${serviceName} Services ${this.convertNumber(totals.bbCurrentTotal)}`,
        `Extra Profit ${this.convertNumber(totals.extraCurrentTotal)}`
      ]
      this.totalsInvoicesCard.income.info = infoIncome
      const income = totals.bbCurrentTotal + totals.extraCurrentTotal + totals.adminCurrentTotal
      this.totalsInvoicesCard.invoiced.sum = this.roundNum(totals.totalInvoiced)
      this.totalsInvoicesCard.received.sum = this.roundNum(totals.totalReceived)
      this.totalsInvoicesCard.income.sum = this.roundNum(income)
      this.totalsInvoicesCard.overpaid.sum = this.roundNum(totals.totalOverpaid)
      this.totalsInvoicesCard.underpaid.sum = this.roundNum(totals.totalNoPaid + totals.totalUnderpaid)
    },
    updateInvoices () {
      this.getInvoices({type: 1})
      this.getInvoicesTotal()
    },
    setFixedThead () {
      const thead = _.get(this, '$refs.bbTheadInvoice', false)
      const theadFirst = _.get(this, '$refs.bbTheadInvoiceFirst', false)
      const theadSecond = _.get(this, '$refs.bbTheadInvoiceSecond', false)
      const table = _.get(this, '$refs.invoiceTable', false)
      const scrollTop = _.get(this.mainScroll, 'target.scrollTop', false)
      if (!table || !thead) return
      const coordinates = table.getBoundingClientRect()
      const top = coordinates ? coordinates.top : 1
      if (top <= 0 && scrollTop) {
        this.theadFixed = true
        thead.forEach(item => {
          item.style.top = -1 * top + 'px'
        })
        if (theadFirst) theadFirst.style.top = -1 * top + 'px'
        if (theadSecond) theadSecond.style.top = -1 * top + 'px'
      } else {
        this.theadFixed = false
        thead.forEach(item => {
          item.style.top = 0
        })
        if (theadFirst) theadFirst.style.top = 0
        if (theadSecond) theadSecond.style.top = 0
      }
    },
    scrollToUp () {
      const parentScroll = _.get(this, '$root.$children[0].$refs.rightPanel.$el', false)
      if (!parentScroll) return
      parentScroll.scrollTop = 0
    },
    setAllProjectManagers (rowId) {
      const projectManagers = []
      const index = _.findIndex(this.invoicesList.invoices, {id: rowId})
      const services = _.get(this.invoicesList.invoices, `${index}.services`, [])
      const bbServices = this.getServicesByCategory(services, 2, false)
      bbServices.forEach(service => {
        projectManagers.push(service.projectManager || false)
      })
      return projectManagers.every(item => item)
    },
    setAllValue () {
      if (!this.invoicesList.invoices) return
      this.columns.forEach(col => {
        _.set(this.allValues, [col.property], {})
        this.invoicesList.invoices.forEach(row => {
          const value = this.getProp(row, col.property, col)
          _.set(this.allValues[col.property], row.id, value)
        })
      })
    }
  },
  updated () {
    if (this.$refs.proformaInvoice) {
      this.proformaEvents.edit = this.$refs.proformaInvoice.editInvoices
      this.proformaEvents.create = this.$refs.proformaInvoice.createInvoice
      this.proformaEvents.cancel = this.$refs.proformaInvoice.cancelProforma
    }
  },
  watch: {
    mainScroll () {
      this.setFixedThead()
    },
    invoicesList () {
      this.setAllValue()
      this.calcWidthTable()
    },
    activeCompany () {
      this.getInvoicesTotal()
      this.getInvoices({})
      this.getUserList()
      this.getContactsList()
    },
    invoicesTotalList (val) {
      this.setTotals(val)
    }
  },
  mounted () {
    const container = _.get(this.$refs, 'invoiceScroll.$el', '')
    if (container) this.preventBackOnHorizontalScroll(container)
  },
  beforeMount () {
    this.updateColumnTitle()
    this.createTotalsInvoicesCard()
    this.activeTab = this.activeTable || 1
    this.setAllValue()
    this.isFounder()
    this.checkDeletedInvoices()
    this.getInvoicesTotal()
    this.getUserList()
    this.getContactsList()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-invoices {
    @include global-font;

    &-tabs {
      position: relative;
      margin-top: 40px;
      display: flex;
      margin-right: 20px;
      z-index: 20;

      &__item {
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 184px;
        min-height: 58px;
        background-color: $color-seashell;
        font-size: 14px;
        font-weight: 500;
        line-height: 17px;
        border-left: 1px solid $color-white;
        border-right: 1px solid $color-white;
        cursor: pointer;
        transition: .15s;

        @media (max-width: 1440px) {
          min-width: 170px;
        }

        &:hover {
          background-color: rgba($color-silver, 0.2);
        }

        &_active {
          background-color: $color-white;
          pointer-events: none;
          z-index: 1;
        }

        &:first-child {
          border-left: none;
          border-top-left-radius: 5px;
        }

        &_last {
          border-right: none;
          border-top-right-radius: 5px;
        }
      }

      &-controls {
        display: flex;
        width: 100%;
        justify-content: flex-end;
        margin-left: 20px;
        margin-right: -20px;

        &__select {
          width: 233px;
          display: flex;
          align-items: center;
          font-size: 14px;
          font-weight: 300;
          height: 42px;
          background-color: $color-white;
          border-radius: 5px;
          z-index: 99999;

          @media (max-width: 1440px) {
            width: 200px;
          }
        }

        &__button {
          margin-left: 20px;
          min-width: 73px;
        }
      }
    }

    .bb-modal-delete-invoice {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      &__number {
        margin: 15px auto;
        font-weight: bold;
      }

      &__text {
        margin-bottom: 25px;
      }

      &__input {
        &_error {
          border-color: $color-red-orange;
        }
      }

      &__button {
        margin-top: 25px;
        width: 117px;
        box-sizing: border-box;
        border: 2px solid rgba($color-red-orange, 1);
        position: relative;
        margin-left: 16px;
        color: $color-red-orange;
        background-color: $color-white;

        &_write-off {
          margin-top: 0;
        }
      }
    }

    &-header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 26px;

      &__buttons {
        display: flex;
        align-items: center;
      }

      &_btn {
        width: 105px;
        height: 42px;

        &:first-child {
          margin-right: 20px;
        }
      }
    }

    &-totals {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -20px;

      &__item {
        flex-grow: 1;
        min-width: 212px;
        margin: 17px 20px;

        &_pointer {
          cursor: pointer;
        }

        &_active {
          box-shadow: 0 0 20px rgba($color-black, 0.1);
        }
      }
    }

    &-table {
      position: relative;

      &__write-off {
        white-space: nowrap;
        padding: 0 15px;
        width: 80px;
        height: 32px;
      }

      &-header {
        background-color: $color-white;
      }

      &__relative {
        position: relative;
      }

      &-wrapper {
        position: relative;
        padding-left: 4px;
        margin-left: -4px;
        padding-bottom: 9px;
        min-height: 200px;
      }

      th {
        &:after {
          opacity: 0;
        }
      }

      &__item {
        position: sticky;
        top: 0;
        background-color: $color-white;
        z-index: 5;

        &-fixed {
          position: sticky !important;
          left: 0;
          background: $color-white;
          z-index: 10;

          &_th {
            z-index: 12;
          }

          &:after {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            height: 1px;
            width: 100%;
            z-index: 2;
            background-color: $color-wild-sand;
          }

          &_write-off {
            padding: 0 15px 0 0;
            min-width: 96px;
          }

          &_toolbar {
            padding-right: 20px;
            left: 20px;
            min-width: 50px;

            &__icon {
              width: 20px;
              height: 51px;
              color: $color-accent;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
            }
          }

          &_nickname {
            text-align: center;
            padding: 0;
            left: 70px;
            min-width: 200px;
            white-space: nowrap;
          }

          &_status-manager {
            padding: 0;
            left: 270px;
            width: 33px;
            min-width: 33px;
          }

          &_number {
            left: 293px;
            padding: 0 25px;
          }

          &_issue-date {
            padding: 0 20px;
          }

          &_extra-value {
            padding-right: 0;
            min-width: 100px;
          }

          &_invoice {
            &:before {
              content: '';
              position: absolute;
              left: -4px;
              top: 0;
              width: 4px;
              height: 100%;
              background-color: $color-wild-sand;
              z-index: 3;
              transition: .1s;
            }
          }
        }

        &_separator {
          background-color: $color-link-water;
        }

        &_center {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        &_nickname {
          padding-left: 57px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        &__nickname {
          display: grid;
          grid-template-columns: 33px 1fr;
          align-items: center;
          justify-content: center;

          &__text {
            border-radius: 7px;
            padding: 7px 8px;

            &_removed {
              text-transform: lowercase;
              color: $color-silver-chalice;
            }
          }
        }
      }

      &-upload-files {
        display: flex;
        align-items: center;
        justify-content: space-between;

        &__input {
          width: 125px;
        }
      }
    }

    &__recovery {
      border-radius: 50%;
      width: 21px;
      height: 21px;
      cursor: pointer;
      z-index: 1;
    }

    &__send {
      position: relative;
      padding-bottom: 0;
      padding-top: 30px;
      margin-right: 8px;
      display: flex;
      justify-content: flex-end;
      box-shadow: 0 -10px 35px -15px rgba($color-silver, 0.4);
    }

    &-extra-button {
      width: 147px;
      margin: auto;
      box-shadow: none;
      justify-content: center;
    }

    &-extra {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      &__title {
        font-weight: bold;
        margin-bottom: 20px;
      }

      &-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        &__title {
          color: $color-accent;
          min-width: 104px;
          margin-right: 20px;
        }
      }
    }
  }
</style>

<style lang="scss">

  .bb-invoices-tabs-controls__select {
    .vs__selected {
      position: absolute;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Finance/InvoiceTable/InvoicesTable.vue